@if (supported) {
  <button
    kendoButton
    type="button"
    class="ask-ryn-dictation__button"
    aria-label="Speak your ask"
    [svgIcon]="listening() ? stopIcon : speakIcon"
    [themeColor]="listening() ? 'error' : 'base'"
    [disabled]="disabled() && !listening()"
    [attr.aria-pressed]="listening()"
    (click)="toggle()"
  >
    {{ listening() ? 'Stop' : 'Speak' }}
  </button>
  <span class="ask-ryn-dictation__message" role="status">{{ message() }}</span>
}
